import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { resolveFlowStateSemaphore, getSemaphoreTitle } from '../../../app/helpers/flowStateSemaphoreHelper';

const FlowStateSemaphore = ({
  stateCatalogId,
  onClick,
  size = 'md',
  showTooltip = true,
  interactive = true
}) => {
  const { t } = useTranslation();
  const { states } = useSelector((state) => state.flowEngine);
  const semaphore = resolveFlowStateSemaphore(stateCatalogId, states);
  const title = getSemaphoreTitle(semaphore, t);
  const iconClass = size === 'lg' ? 'fa-lg' : '';
  const colorClass = semaphore.styleColor ? '' : `text-${semaphore.color}`;
  const style = semaphore.styleColor ? { color: semaphore.styleColor } : undefined;
  const icon = <i className={`fa ${semaphore.icon} ${iconClass}`} aria-hidden="true" />;

  if (!interactive) {
    return (
      <span
        className={colorClass}
        style={style}
        title={showTooltip ? title : undefined}
        aria-label={title}
      >
        {icon}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={`btn btn-link p-0 ${colorClass}`}
      style={style}
      onClick={onClick}
      title={showTooltip ? title : undefined}
      aria-label={title}
    >
      {icon}
    </button>
  );
};

FlowStateSemaphore.propTypes = {
  stateCatalogId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['md', 'lg']),
  showTooltip: PropTypes.bool,
  interactive: PropTypes.bool
};

export default FlowStateSemaphore;
